<template>
	<div class="register">
		<el-main>
		  	<div style="margin: 20px;"></div>
			<el-form :label-position="labelPosition" :rules="rules" ref="addForm"  label-width="80px" :model="addForm">
				<h3 class="title">用户注册</h3>
			  <el-form-item
			    label="手机号"
			    prop="mobile"
			    :rules="[
			      { required: true, message: '手机号不能为空'},
			      { type: 'number', message: '手机号必须为数字值'}
			    ]"
			  >
			    <el-input v-model.number="addForm.mobile" auto-complete="off" placeholder="请输入手机号" :maxlength="11"></el-input>
			  </el-form-item>
			  <el-form-item label="验证码"
			  	prop="type"
			  	:rules="[
			      { required: true, message: '手机号不能为空'},
			      { type: 'number', message: '手机号必须为数字值'}
			    ]">
			    <input v-model="addForm.type" placeholder="请输入验证码" id="code" :maxlength="6"></input>
          		<el-button type="primary" @click="sendCode" v-if="codeMsg=='发送验证码'" class="sendcode">{{codeMsg}}</el-button>
          		<el-button type="primary" v-else disabled class="sendcode">{{codeMsg}}</el-button>
			  </el-form-item>
			  <div class="btn">
			    <span type="primary" @click="sure" class="el-button--primary el-button sure1">下一步</span>
			  </div>
			</el-form>
		  </el-main>
		  
	</div>
</template>

<script>
	import axios from 'axios'
	export default{
		data(){
			return{
				labelPosition:'left',
				rules: {
			          mobile: [
			            { required: true, message: 's', trigger: 'blur' },
			          ]
				},
				addForm:{
					mobile:'',
					type:'reg',
				},
				codeMsg:"发送验证码"
			}
		},
		methods:{
			sure(){
				this.$router.push('/registered')
			},
			sendCode(){
				console.log(this.codeMsg)
				var num=60;
				var that=this
				var set=	setInterval(function(){ 
						if(num>1){
						num--
						that.codeMsg=num+'s后重新发送'
						}else{
							
							clearInterval(set)
							that.codeMsg="发送验证码"
							return num=60;
						}
					}, 1000);
				axios.post('/marlin/sign/sms/send',this.addForm)
				.then(function(res){
					console.log(res)
				})
				.catch(function(res){
					
				})
			}
		}
	}
</script>

<style scoped lang="less">
.register{
	.el-main{
		display: flex;
		height:600px;
		flex-direction: column;
		justify-content: center;
	}
	.title{
		text-align: center;
	}
	.el-form{
		width:450px;
		margin: auto;
	}
	#code{
		width:250px;
		-webkit-appearance: none;
	    background-color: #fff;
	    background-image: none;
	    border-radius: 4px;
	    border: 1px solid #dcdfe6;
	    -webkit-box-sizing: border-box;
	    box-sizing: border-box;
	    display: inline-block;
	    font-size: inherit;
	    height: 40px;
	    line-height: 40px;
	    outline: 0;
	    padding: 0 15px;
	}
	input::-webkit-input-placeholder{
            color:#c4c8cf;
        }
        input::-moz-placeholder{   /* Mozilla Firefox 19+ */
            color:#c4c8cf;
        }
        input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
            color:#c4c8cf;
        }
        input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
            color:#c4c8cf;
        }
	#code:focus{
		border-color: #409EFF;
	}
	.btn{
		text-align: center;
		.sure1{
			width: 100px;
		}
	}
	.sendcode{
		width: 115px !important;
		padding: 12px 10px;
	}
}
	
</style>


// WEBPACK FOOTER //
// src/components/register.vue